/* eslint-disable indent */
import React from "react";
import { useCurrency } from "../../../utils/useCurrency";
import styles from "../stylesER.module.scss";

const mesesAbrev = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

const mostrarFecha = (fechaStr) => {
  if (!fechaStr) return "Ingresar fecha";
  const [, month, day] = fechaStr.split("-");
  return `${day}-${mesesAbrev[parseInt(month) - 1]}`;
};

// formatAmount sólo reconoce "USD" exacto; normalizamos "US$" para preservar el prefijo "US$ "
const normMoneda = (m) => {
  const u = (m || "").toUpperCase();
  return u === "US$" ? "USD" : u;
};

export const GestionContenidosModal = ({
  isOpen,
  monthIndex,
  selectedYear,
  currentYear,
  mesesCompletos,
  pais,
  localString: _localString,
  moneda,
  formatCurrency: _formatCurrency,
  formatFee: _formatFee,
  getDolarValue,
  convertirAMonedaLocal: _convertirAMonedaLocal,
  detalleItems,
  costosGestionData,
  // Props mantenidos por compatibilidad (edición deshabilitada, solo lectura)
  editingFechaId: _editingFechaId,
  setEditingFechaId: _setEditingFechaId,
  editingFechaValue: _editingFechaValue,
  setEditingFechaValue: _setEditingFechaValue,
  onSaveFecha: _onSaveFecha,
  onClose,
}) => {
  const { formatAmount } = useCurrency();
  if (!isOpen || monthIndex === null) return null;

  const ultimoDiaMes = new Date(currentYear, monthIndex + 1, 0);
  const fechaUltimoDia = ultimoDiaMes.toISOString().split("T")[0];
  const monedaLocal = pais === "Chile" ? "CLP" : "PEN";

  const totalAgregado = detalleItems.reduce((sum, item) => sum + (item.totalLocal || 0), 0);

  const fechaParaOrdenar = (item) => {
    if (item.facturaFecha) return item.facturaFecha;
    const negocioId = Number(item.id);
    const registro = costosGestionData.find(
      (c) => Number(c.negocio_id) === negocioId && Number(c.mes) === monthIndex + 1 && Number(c.ano) === selectedYear
    );
    return registro?.fecha_factura?.split("T")[0] || null;
  };
  const itemsOrdenados = [...detalleItems].sort((a, b) => {
    const fa = fechaParaOrdenar(a);
    const fb = fechaParaOrdenar(b);
    if (!fa && !fb) return 0;
    if (!fa) return 1;
    if (!fb) return -1;
    return fa.localeCompare(fb);
  });

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContent}
        style={{ maxWidth: "1240px", width: "95%", margin: "20px auto" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3>
          Detalle Gestión & Contenidos - {mesesCompletos[monthIndex]} {selectedYear}
        </h3>
        <div style={{ overflowX: "auto" }}>
          <table className={styles.modalTable} style={{ tableLayout: "fixed", minWidth: "950px" }}>
            <colgroup>
              <col style={{ width: "5%" }} />
              <col style={{ width: "5%" }} />
              <col style={{ width: "11%" }} />
              <col style={{ width: "18%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "8%" }} />
              {pais === "Perú" && <col style={{ width: "8%" }} />}
              <col style={{ width: "14%" }} />
            </colgroup>
            <thead>
              <tr>
                <th>ID</th>
                <th>TIPO</th>
                <th>FECHA FACTURA</th>
                <th>CLIENTE / EDIFICIO</th>
                <th>FEE GESTIÓN</th>
                <th>FEE CONTENIDOS</th>
                <th>TOTAL PANTALLA</th>
                <th>PANTALLAS</th>
                {pais === "Perú" && <th>VALOR DÓLAR</th>}
                <th>TOTAL MENSUAL {moneda(pais)}</th>
              </tr>
            </thead>
            <tbody>
              {itemsOrdenados.map((item) => {
                const negocioId = Number(item.id);
                const registro = costosGestionData.find(
                  (c) =>
                    Number(c.negocio_id) === negocioId &&
                    Number(c.mes) === monthIndex + 1 &&
                    Number(c.ano) === selectedYear
                );
                const fechaFacturaGuardada = item.facturaFecha || registro?.fecha_factura?.split("T")[0] || null;
                const fechaUsada = fechaFacturaGuardada || fechaUltimoDia;

                const gestionMoneda = item.gestionMoneda?.toUpperCase() || "";
                const contenidosMoneda = item.contenidosMoneda?.toUpperCase() || "";
                const esUSD = gestionMoneda.includes("US") || contenidosMoneda.includes("US");
                const valorDolar = esUSD ? getDolarValue(fechaUsada) : null;

                const totalMensualLocal = item.totalLocal || 0;
                const valorPorPantalla = item.pantallas > 0 ? totalMensualLocal / item.pantallas : 0;

                return (
                  <tr key={item.id}>
                    <td style={{ textAlign: "center", fontWeight: "600" }}>{item.id}</td>
                    <td style={{ textAlign: "center" }}>{item.tipo}</td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      <span
                        style={{
                          backgroundColor: fechaFacturaGuardada ? "#e8f5e8" : "#ffebee",
                          color: fechaFacturaGuardada ? "#1b5e20" : "#c62828",
                          padding: "8px 16px",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "13px",
                          display: "inline-block",
                        }}
                      >
                        {fechaFacturaGuardada ? mostrarFecha(fechaFacturaGuardada) : "Sin fecha"}
                      </span>
                    </td>
                    <td style={{ textAlign: "left", paddingLeft: "12px", fontWeight: "500" }}>{item.nombre}</td>
                    <td style={{ textAlign: "center" }}>
                      {item.gestionUnitario > 0
                        ? formatAmount(item.gestionUnitario, normMoneda(item.gestionMoneda))
                        : "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item.contenidosUnitario > 0
                        ? formatAmount(item.contenidosUnitario, normMoneda(item.contenidosMoneda))
                        : "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {valorPorPantalla > 0 ? formatAmount(valorPorPantalla, monedaLocal) : "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>{item.pantallas}</td>
                    {pais === "Perú" && (
                      <td style={{ textAlign: "center" }}>
                        {esUSD
                          ? valorDolar.toLocaleString("es-PE", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "-"}
                      </td>
                    )}
                    <td style={{ textAlign: "right", fontSize: ".9rem", color: "#1b5e20" }}>
                      {formatAmount(totalMensualLocal, monedaLocal)}
                    </td>
                  </tr>
                );
              })}
              <tr style={{ backgroundColor: "#e3f2fd", fontWeight: "bold" }}>
                <td colSpan={pais === "Perú" ? 9 : 8} />
                <td style={{ textAlign: "right", fontSize: "1rem", color: "#1b5e20" }}>
                  {formatAmount(totalAgregado, monedaLocal)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
